import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import http from '../Http';
import utils from "../utils";
import ReactECharts from 'echarts-for-react';
import { DatePicker } from 'antd';
import moment from 'moment';
import * as XLSX from 'xlsx';

function SOC(props) {
    const { t } = useTranslation();
    const { setTip, deviceInfo, date, setDate } = props;


    const chartEl = useRef(null);
    const chart = useRef(null);
    const data = useRef(null);

    const exportToExcel = () => {
        if (data.current == null || deviceInfo == null) {
            return;
        }

        let rs = 
        data.current.map((v) => {
            let r = {};
            r[t("DataTime")] = v['CreateTime'];
            r[t("SOC")] = v['SOC']/10;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 6}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, deviceInfo.SN + '_SOC.xlsx');
    }

    const option = {
        darkMode: true,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            },
        },
        legend: {
            show: false,
        },
        toolbox: {
            right: 40,
            feature: {
                myDownloadXls: {
                    show: true,
                    title: t("Download"),
                    icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                    onclick: () => {
                        exportToExcel();
                    }
                }
            }
        },
        grid: {
            left: 40,
            right: '4%',
            bottom: 40,
            containLabel: true
        },
        xAxis: {
            type: 'time',
            name: t('curve_axis.hour'),
            nameLocation: "center",
            nameGap: 25,
            splitNumber: 24,
            axisLabel: {
                formatter: '{H}'
            },
        },
        yAxis: [
            {
                type: 'value',
                name: t('curve_axis.percentage'),
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 40,
            }
        ],
        series: [{
            name: t('SOC'),
            type: 'line',
            stack: '',
            smooth: true,
            lineStyle: {
                width: 1,
                color: "blue"
            },
            showSymbol: false,
            areaStyle: {
                opacity: 0,
            },
            emphasis: {
                focus: 'none'
            },
            data: []
        }]
    };

    useEffect(() => {
        if(deviceInfo == null) {
            return;
        }

        let active = true;
        const st = utils.dateFormat("YYYY-mm-dd", date);
        let date2 = new Date(st);
        date2.setDate(date2.getDate()+1)
        const et = utils.dateFormat("YYYY-mm-dd", date2);

        (async () => {
            let resp = await http.post("report/device/soc/daily/report", {
                "DeviceID": deviceInfo.ID,
                "STime": st,
                "ETime": et,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("Report Voltage", e);
                return null;
            });

            if (!active) {
                return;
            }

            if (resp == null || resp.code != 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : "load data error" });

                option.series[0].data = [];
            } else {
                let soc = [];
                if(resp.data instanceof Array) {
                    resp.data.forEach((v) => {
                        soc.push([v['CreateTime'], v['SOC']/10])
                    });
                    //填充数据
                    let min = resp.data[0]['CreateTime'],
                        max = resp.data[resp.data.length-1]['CreateTime'];
                    if(min >= min.substring(0, 10) + ' 01:00:00') {
                        soc.unshift([utils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(new Date(min).getTime()-1000)), 0])
                        soc.unshift([min.substring(0, 10) + ' 00:00:01', 0])
                    }
                    if(max <= max.substring(0, 10)+' 23:00:00') {
                        soc.push([utils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(new Date(max).getTime()+1000)), 0])
                        soc.push([max.substring(0, 10)+' 23:59:59', 0])
                    }
                }
                option.series[0].data = soc;
            }

            //
            const instance = chart.current.getEchartsInstance();
            if (instance) {
                instance.setOption(option);
            }

            data.current = resp.data;
        })();

        return () => {
            active = false;
        };
    }, [deviceInfo, date]);

    const handleGoPreDay = () => {
        setDate(new Date(date.setDate(date.getDate() - 1)));
    }

    const handleGoNextDay = () => {
        if (utils.dateFormat("YYYY-mm-dd", date) >= utils.dateFormat("YYYY-mm-dd", new Date())) {
            setTip({ open: true, severity: "info", msg: "date exceeded" });
            return;
        }

        setDate(new Date(date.setDate(date.getDate() + 1)));
    }

    return (
        <div style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            backgroundColor: "white",
            overflow: 'auto',
            borderRadius: 10,
        }}>
            <div style={{
                flex: '1 0 20px',
                display: "flex",
                justifyContent: 'center',
                alignItems: "flex-end",
                color: "white",
                fontSize: 20,
            }}>
                <DatePicker
                    locale="en"
                    onChange={(v) => {
                        setDate(v.toDate());
                    }}
                    //defaultValue={moment()}
                    value={moment(date)}
                    style={{ borderRadius: '20px' }}
                />
            </div>
            <div style={{
                flex: "1 1 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: 'stretch',
                overflow: "auto",
                padding: 5,
                backgroundColor: "white",
            }}>
                <div style={{
                    flex: "1, 1 auto",
                    minWidth: 400,
                }} ref={chartEl}>
                    <ReactECharts ref={chart} option={option} style={{ height: 400 }} />
                </div>
            </div>
        </div>
    )
}

export default SOC;